// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"d5e5de81","431":"b4763bee","874":"f04d7d30"}[chunkId] + ".chunk.js";
};